<template>
  <v-dialog v-model="dialog" max-width="75%">
    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-observer ref="observer">
            <v-form>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="newService"
                    label="Service"
                    :disabled="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="newTime" label="ADL Time"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="newAssistance"
                    label="Level of Assistance"
                    :items="assistance"
                    :rules="requiredRules"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6" v-if="hasBPKey">
                  <v-text-field
                    v-model="bloodPressure"
                    label="Blood Pressure"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    clearable
                    v-model="newException"
                    label="Exception"
                    :items="exception"
                    :rules="requiredRules"
                  ></v-autocomplete>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6" style="position: relative">
  
                  <v-text-field
                  class="update-icon"
                  v-model="newSignature"
                  label="Signature"
                  :readonly="basicStaff"
                  clearable
                >
                  <template slot="append">
                    <v-btn icon @click="onUpdateSignature()">
                      <v-icon>mdi-pencil-box-outline</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="12"
                  sm="6"
                  style="position: relative"
                  v-if="canVerified"
                >
                  <v-text-field
                    class="update-icon mt-n1"
                    v-model="newVerifiedBy"
                    label="Verified By"
                    @click="onVerifiedBySignature"
                    clearable
                  >
                    <template slot="append" v-if="canUpdate">
                      <v-btn icon @click="onVerifiedBySignature()">
                        <v-icon>mdi-pencil-box-outline</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Notes"
                    rules="required"
                  >
                    <v-textarea
                      label="Add Notes"
                      v-model="newNotes"
                      :error-messages="errors"
                    >
                    </v-textarea>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-form>
          </validation-observer>
        </v-container>
      </v-card-text>

      <v-card v-if="newService === 'Skin Check'">
        <v-card-title>
          <v-col
            cols="12"
            class="white--text text-uppercase text-center text-subtitle-1"
            style="background-color: #2b3990"
          >
            <h5>Body Check Images</h5>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="fill-height" fluid style="min-height: 434px">
            <v-row
              class="flex-column justify-center align-center"
              v-if="!$store.getters['adl/getADLAttachments'].Attachments"
            >
              <div class="mb-2">
                <h2>No Images Added</h2>
              </div>
              <div>
                <v-btn v-if="!isAuditorRole" color="primary" @click="openSkinCheckDialog">Add</v-btn>
              </div>
            </v-row>
            <skin-check v-else />
          </v-container>
        </v-card-text>
      </v-card>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn class="blue darken-2 white--text" text @click="addADL()" v-if="newService">Save</v-btn
                                > -->
        <v-btn color="blue darken-1" text @click="onUpdateItem" v-if="editADL && !isAuditorRole"
          >Update</v-btn
        >
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable*/
// import moment from "moment";
import SkinCheck from "./SkinCheck";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    SkinCheck,
    ValidationProvider, 
    ValidationObserver
  },
  props: {
    itemData: {
      type: Object,
    },
    updatedSignature: {
      type: String,
    },
    verifiedSignature: {
      type: String,
    },
    unsigned: {
      type: Boolean,
    },
    isAuditorRole: {
      type: Boolean,
      default: false,  
    }
  },
  data() {
    return {
      titleForm: "Update ADL Item",
      newDate: "",
      newTime: "",
      newAssistance: "",
      newException: "",
      newNotes: "",
      newSignature: "",
      newService: "",
      assistance: [
        "Independant",
        "Minimal Assistance",
        "Moderate Assistance",
        "Total Assistance",
      ],
      exception: ["Refused", "ADL on Hold", "Absent", "Other"],
      editADL: false,
      requiredRules: [],
      adlID: null,
      clientID: this.$route.params.clientID,
      canUpdate: false,
      roles: [
        "Administration",
        "Program Coordinator",
        "Client Services Manager",
        "Compliance Manager",
        "Human Resources",
        "Medical Manager",
      ],
      canVerifyRole: ["Administration", "Medical Manager"],
      servicePlan: [],
      hasAttachment: false,
      newVerifiedBy: "",
      bloodPressure: "",
      canVerified: false,
      hasBPKey: false,
      userRole: localStorage.getItem("userRole"),
      basicStaffRole: ["Direct Care Staff", "Assistant Manager", "Shift Lead", "House Manager" ]
    };
  },

  computed: {
    dialog: {
      get() {
        return this.$store.state.services.dialog;
      },
      set(val) {
        this.$store.commit("services/SET_DIALOG", val);
      },
    },

    basicStaff() {
      if(this.basicStaffRole.includes(this.userRole)){
        return true
      }
      return false
    },
  },

  // watch:{
  //   servicePlan(val){
  //     this.hasAttachment = val.Attachments.length != 0
  //   }
  // },

  methods: {
    onViewItem(item) {
      this.hasBPKey = false
      this.adlItemData = item;
      this.titleForm = "Viewing ADL";
      this.dialog = true;
      this.editADL = true;
      this.newADL = false;
      this.newService = item.Service.ServiceItem;
      this.newDate = item.Date;
      this.newTime = item.Time;
      this.newAssistance = item.Assistance;
      this.newException = item.Exception;
      this.newNotes = item.Notes;
      this.newSignature = item.Signature;
      this.newClientID = item.ClientID;
      this.adlID = item._id;


      if(('BloodPressure' in item)){
        this.hasBPKey = true
        this.bloodPressure = item.BloodPressure;
      }

      this.servicePlan = item.Service;
      if (
        this.canVerifyRole.includes(this.$store.state.users.user.Role) &&
        item.Service.ServiceItem === "Skin Check" &&
        item.Service.Attachments.length > 0
      )
        this.canVerified = true;

      this.canUpdateSignature();
    },

    canUpdateSignature() {
      if (this.adlItemData.Signature === "") return (this.canUpdate = true);

      if (this.roles.includes(this.$store.state.users.user.Role)) {
        return (this.canUpdate = true);
      }
      return (this.canUpdate = false);
    },

    async onUpdateItem() {
      var data = {
        Date: this.newDate,
        Time: this.newTime,
        Assistance: this.newAssistance,
        Exception: this.newException,
        Notes: this.newNotes,
        ClientID: this.clientID,
        Signature: this.newSignature || "",
        UrlNotification: this.$router.history.current.path,
        ServiceName: `${this.servicePlan.Type} - ${this.servicePlan.ServiceItem}`,
        VerifiedBy: this.newVerifiedBy || "",
        // ServiceId: this.servicePlan._id,
        Service: this.servicePlan,
        BloodPressure: this.bloodPressure,
        DateSigned: new Date().toString()
      };

      let isValid = await this.$refs.observer.validate();

      if(isValid) this.$emit("updateADL", data, this.adlID, this.unsigned);

    },

    onVerifiedBySignature() {
      this.$emit("verifiedBySignature");
      this.$nextTick(() => {
        this.newVerifiedBy = this.verifiedSignature;
      });
    },

    onUpdateSignature() {
      this.$emit("updateSignature");
      this.$nextTick(() => {
        this.newSignature = this.updatedSignature;
      });
    },

    openSkinCheckDialog() {
      const {_id, Time, Service, ClientID, createdAt } = this.adlItemData;

      const service = {
        _id: Service._id,
        ClientID,
        adlId: _id,
        ServiceItem: Service.ServiceItem,
        scheduleTime: Time,
        date: new Date(createdAt)
      };

      this.$emit("openSkinCheckDialog", service);
    },

    clear() {
      this.newVerifiedBy = "";
      this.canVerified = false;
    },

    close() {
      this.clear();
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.update-icon >>> .mdi-pencil-box-outline {
  color: #5a99f6;
}
</style>
